import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import StatusAlertModel from "../../../../components/statusAlertModel/StatusAlertModel";
import UsageSummeryContainer from "../../../../components/usageSummeryContainer/UsageSummeryContainer";
import { EPackageType } from "../../../../interfaces/packageType";
import { ISuccessState } from "../../../../interfaces/successState";
import BroadbandUsage from "./broadbandUsage/BroadbandUsage";
import NoneBroadbandUsage from "./noneBroadbandUsage/NoneBroadbandUsage";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BarChartIcon from "@mui/icons-material/BarChart";

interface IProps {
  selectedCircuitId?: string;
  selectedPackageType: EPackageType;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const DailyUsage = (props: IProps) => {
  const [isSuccess, setIsSuccess] = useState<ISuccessState | undefined>();
  const navigate = useNavigate();

  return (
    <>
      {/* <Button
        variant="contained"
        startIcon={<BarChartIcon />}
        sx={{
          background: "#04559F",
          color: "#fff",
          fontSize: "1rem",
          fontWeight: "bold",
          padding: "20px",
          borderRadius: "16px",
          height: "30px",
          boxShadow: 3,
          marginTop: "20px",
          "&:hover": {
            background:
              "linear-gradient(135deg,rgba(33, 91, 109, 0.66),rgba(18, 52, 62, 0.96))",
          },
        }}
        onClick={() => navigate("/serviceLineUp/detailedReport")}
      >
        Enable/Disable Protocol Report
      </Button> */}
      <UsageSummeryContainer title="View Data Usage Summary">
        <Row className="justify-content-center my-3">
          <Col className="col-md-11">
            {props.selectedPackageType === EPackageType.BROADBAND ? (
              <BroadbandUsage setIsSuccess={setIsSuccess} {...props} />
            ) : (
              <NoneBroadbandUsage {...props} setIsSuccess={setIsSuccess} />
            )}
          </Col>
        </Row>
        <StatusAlertModel setIsSuccess={setIsSuccess} isSuccess={isSuccess} />
      </UsageSummeryContainer>
    </>
  );
};

export default DailyUsage;
